<template>
	<transition
			appear
			:appear-active-class="$_ifrmLyt_stylePageTitleLayoutAnimation()">
		<v-row no-gutters>
			<v-col>
				<iframe	class="iframe_"
						frameborder="0"	
						scrolling="auto"
						:src="$_ifrmLyt_linkIframeSrc" />
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'IframeLayout',
		props: {
			inits: Object
		},
		computed: {
			// link
			$_ifrmLyt_linkIframe() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'iframe')
			},
			$_ifrmLyt_linkIframeSrc() {
				const self_ = this;
				const link_ = self_.$_ifrmLyt_linkIframe;
				return link_.src
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.iframe_ {
			margin-bottom: -32px;

			height: calc( ( 100vh - 64px ) ) !important;
			width: 100vw;
		}
	}
	@media screen and (max-width:959px) {
		.iframe_ {
			margin-bottom: -24px;

			height: calc( ( 100vh - 56px ) ) !important;
			width: 100vw;
		}
	}
</style>
